import ruFlag from "@/assets/icons/flags/ru.svg";
// import enFlag from "@/assets/icons/flags/en.svg";
import kyFlag from "@/assets/icons/flags/ky.svg";
// import tgFlag from "@/assets/icons/flags/tg.svg";
import uzFlag from "@/assets/icons/flags/uz.svg";

import { LANG_LABEL, ILanguageOption } from "../types";

export const LANGUAGES: ILanguageOption[] = [
  {
    code: "ru",
    label: LANG_LABEL.RU,
    icon: ruFlag,
  },
  // {
  //   code: "en",
  //   label: LANG_LABEL.EN,
  //   icon: enFlag,
  // },
  {
    code: "kg",
    label: LANG_LABEL.KG,
    icon: kyFlag,
  },
  // {
  //   code: "tg",
  //   label: LANG_LABEL.TG,
  //   icon: tgFlag,
  // },
  {
    code: "uz",
    label: LANG_LABEL.UZ,
    icon: uzFlag,
  },
];
